import React from "react"
import { Link } from "gatsby"
import ImageShow from "../ImageShow/showImage"
import LinkedinBlack from "../../components/svg/linkdin-black"
import * as style from "./webinarSolution.module.css"
import SectionsTitle from "../../Common/new/SectionsTitle"

const WebinarSolution = ({ speakersTag, speakersTitle, speakersList }) => {
  return (
    <section className={style.solution_section}>
      <div className="container">
        <div>
          {/* <div className={style.mix_heading}>
              <span>{speakersTag}</span>
              <h2 > {speakersTitle} </h2>
            </div> */}

          <SectionsTitle
            title={speakersTag}
            SubTitle={speakersTitle}
            // Content={parse(`${aboutContent}`)}
            classnames="webinarSpeakerTitle"
            styleCss={{ display: "none" }}
          />

          <div className={style.image_wrapper}>
            {speakersList.map(data => (
              <div className={style.col_5}>
                <ImageShow
                  imageData={data?.photo?.mediaItemUrl}
                  alt={data?.photo?.altText}
                />
                <div className={style.img_title}>
                  <div className={style.name_box}>
                    <figcaption>{data?.speakerName} </figcaption>
                    <Link
                      to={data?.linkedProfileLink.url}
                      title={data?.linkedProfileLink.title}
                    >
                      <LinkedinBlack />
                    </Link>
                  </div>
                  <span>{data?.designation}</span>
                  <strong>{data?.company}</strong>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default WebinarSolution
